<template>
	<main id="contact" class="mt-6 sm:mt-0 relative">
		<article class="h-full w-full">
			<img class="fixed h-full hidden sm:block object-cover w-full z-c" src="images/map.jpg" alt="Karte Osterode" />

			<article class="flex items-center justify-center w-full h-full">
				<div class="arrow bg-red-9 flex flex-col h-full sm:h-auto justify-center shadow-xl relative rounded-sm p-6">
					<h1 class="text-3xl text-gray-9">
						Besuch uns!
					</h1>
					<h1 class="uppercase leading-none  text-6xl text-gray-0">
						Waagestraße 3a
					</h1>
					<span class="text-2xl">
						37520 Osterode
					</span>
				</div>
			</article>
		</article>
	</main>
</template>

<style scoped>
	#contact {
		height: 100%;
	}

	.arrow {
		font-family: 'Bebas Neue', cursive;
	}

	.arrow::after {
		border-top: 30px solid transparent;
		border-bottom: 30px solid transparent;
		border-left: 30px solid #c92a2a;
		content: "";
		height: 0;
		left: 100%;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 0;
	}
</style>

<script>
	export default {
		name: 'contact'
	};
</script>
